import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { isMobileDevice } from '@src/quince-site-common/src/helpers/getDeviceTypeForPageRouter'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

import { Home } from './[...slug]/components/homepage'
import Layout from './layout'

export const getServerSideProps = (async ctx => {
  // eslint-disable-next-line i18next/no-literal-string
  const serverSideBaseProps = await getServerSideBaseProps(ctx, '/New-home-design')
  // Pass data to the page via props
  // res.setHeader()
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageHome(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout {...props}>
      {props.pageData ? (
        <div className="new-home-design-page">
          <Home pageContext={props.pageData.context?.pageDataJson} isMobile={isMobileDevice(props.deviceType)} />
        </div>
      ) : (
        <SomethingWentWrong />
      )}
    </Layout>
  )
}
